import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";

declare var ko: any;


export class heavyHitters_template extends vnTemplate{

    // filters
    protected brandsFilter : multipleSelector_template;
    protected brandSegmentsFilter : multipleSelector_template;
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    protected ideatorsFilter: filterMultipleAutoComplete_template;
    protected authorsFilter: filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postPaymentCategorySystemFilter: multipleSelector_template
    protected primaryCategoriesFilter : filterAutoComplete_template;
    protected primaryTagFilter : filterAutoComplete_template;
    protected tagsFilter : filterAutoComplete_template;
    protected tagTypesFilter : filterAutoComplete_template;
    protected articleTypesFilter : multipleSelector_template;



    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    public chart: amCharts_v4_date_basic_template;

    readonly contentTypesGroup : Array<{id : string, name : string}> = [
        { "id": "all", "name": "all"},
        { "id": "shortForm", "name": "Short"},
        { "id": "longForm", "name": "Long"}
    ];

    readonly articleTypes : Array<{id : string, name : string}> = [
        {"id": "regular", "name": "Regular"},
        {"id": "video", "name": "Video"},
        {"id": "thread", "name": "Thread"},
    ];

    protected getTemplateHtml(): string{

        return  /*html*/`
            <div class="sub-header w-justify">
            
                ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                
                    ${this.brandsFilter.getHtmlBuild()}
                    ${this.brandSegmentsFilter.getHtmlBuild()}
                    <div class="is-hidden">${this.postInitiativesFilter.getHtmlBuild()} </div>                    
                    ${this.postIntentsFilter.getHtmlBuild()} 
                    ${this.postContentTypesFilter.getHtmlBuild()} 
                    ${this.articleTypesFilter.getHtmlBuild()}
                    ${this.networkCategoriesFilter.getHtmlBuild()}
                    ${this.postPaymentCategorySystemFilter.getHtmlBuild()}
                    ${this.primaryCategoriesFilter.getHtmlBuild()}
                    ${this.primaryTagFilter.getHtmlBuild()}
                    ${this.tagsFilter.getHtmlBuild()}
                    <div class="is-hidden">${this.tagTypesFilter.getHtmlBuild()} </div>
                    ${this.srEditorsFilter.getHtmlBuild()}
                    ${this.jrEditorsFilter.getHtmlBuild()} 
                    ${this.authorsFilter.getHtmlBuild()}
                    <div class="is-hidden">${this.ideatorsFilter.getHtmlBuild()} </div>
                    ${this.datesFilter.getHtmlBuild()}
                    <div class="content-form-radio">
                        <div class="title" style="font-family:Lato, sans-serif">Form</div>
                        <form >
                            <div style="display: flex; gap:0.5rem" data-bind="foreach: formOptions">
                            <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                            <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                            </div>
                        </form>
                    </div> 
                </div>
                 
            </div>
            
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-dimensions"></div>
                   <div id="selected-brands"></div>
                   <div id="selected-brand-segments"></div>
                   <div id="selected-video-placement"></div>
                   <div class="is-hidden" id="selected-initiatives"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-systems"></div>
                   <div id="selected-sr-editors"></div>
                   <div id="selected-jr-editors"></div>
                   <div id="selected-authors"></div>
                   <div id="selected-ideators"></div>
                   <div id="selected-article_types"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
            
                <div class="w-left">
                    <h2 class="section-title icon i-roi">Heavy Hitters</h2>
                </div>
            </div>
            <div data-bind="css: { loading: isDataLoading }">   
                <section class="w-graph">
                    <div class="graph">
                        ${this.chart.getHtmlBuild()}
                    </div>
                </section>
            </div>

             <div class="list-header w-justify"> 
                <div class="w-left"> 
                    <ul>
                        <li><strong>aS/A: This is the 7 day rolling average of the 72 Hour Active Sessions per Article</strong></li>
                        <li><strong>HH Daily Target is calculated at 10% of total output</strong></li>
                    </ul>
                </div>
            </div>
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('heavyHitters');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.brandSegmentsFilter = new multipleSelector_template("brandSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.brandSegmentsFilter.setTagContainerId('selected-brand-segments');
        this.brandSegmentsFilter.setTagContainerCaption('Selected segments:');
        this.brandSegmentsFilter.setLabel("segments");
        this.brandSegmentsFilter.setLogoEnabled(false);

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.postPaymentCategorySystemFilter = new multipleSelector_template("postPaymentCategorySystemFilter", this.getTemplateViewModel(), this.caller);
        this.postPaymentCategorySystemFilter.setLabel("System");
        this.postPaymentCategorySystemFilter.setFilterContainerClass('margin-neg');
        this.postPaymentCategorySystemFilter.setTagContainerId('selected-systems');
        this.postPaymentCategorySystemFilter.setTagContainerCaption('Selected systems:');

        this.primaryCategoriesFilter = new filterAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");

        this.primaryTagFilter = new filterAutoComplete_template("primaryTagFilter", this.getTemplateViewModel(), this.caller);
        this.primaryTagFilter.setIsVisible(1);
        this.primaryTagFilter.setPlaceHolderText("Primary Tag");
        this.primaryTagFilter.setIcon("i-tag-a");

        this.tagsFilter = new filterAutoComplete_template("tagsFilter", this.getTemplateViewModel(), this.caller);
        this.tagsFilter.setIsVisible(1);
        this.tagsFilter.setPlaceHolderText("Tags");
        this.tagsFilter.setIcon("i-tag-a");

        this.tagTypesFilter = new filterAutoComplete_template("tagTypesFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypesFilter.setIsVisible(1);
        this.tagTypesFilter.setPlaceHolderText("Tag Types");
        this.tagTypesFilter.setIcon("i-tag-a");

        this.ideatorsFilter = new filterMultipleAutoComplete_template("ideatorsFilter", this.getTemplateViewModel(), this.caller);
        this.ideatorsFilter.setIsVisible(1);
        this.ideatorsFilter.setPlaceHolderText("Ideator");
        this.ideatorsFilter.setIcon("i-user2");
        this.ideatorsFilter.setTagContainerId('selected-ideators');
        this.ideatorsFilter.setTagContainerCaption('Selected Ideators:');
        this.ideatorsFilter.setMinInputSuggestionLength(2);

        this.authorsFilter = new filterMultipleAutoComplete_template("authorsFilter", this.getTemplateViewModel(), this.caller);
        this.authorsFilter.setIsVisible(1);
        this.authorsFilter.setPlaceHolderText("Writer");
        this.authorsFilter.setIcon("i-user2");
        this.authorsFilter.setTagContainerId('selected-authors');
        this.authorsFilter.setTagContainerCaption('Selected Writers:');
        this.authorsFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Sr Editor");
        this.srEditorsFilter.setIcon("i-user2");
        this.srEditorsFilter.setTagContainerId('selected-sr-editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Sr Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Jr Editor");
        this.jrEditorsFilter.setIcon("i-user2");
        this.jrEditorsFilter.setTagContainerId('selected-jr-editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Jr Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.articleTypesFilter = new multipleSelector_template("articleTypesFilter", this.getTemplateViewModel(), this.caller);
        this.articleTypesFilter.setLabel("page types");
        this.articleTypesFilter.setTagContainerId('selected-article_types');
        this.articleTypesFilter.setTagContainerCaption('Selected page types:');
        this.articleTypesFilter.setSelectionLimit(1);


        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        this.chart = new amCharts_v4_date_basic_template("chart", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        date.setDate(date.getDate() - 2);
        let dateStart = new Date();
        dateStart.setHours(0,0,0,0);
        dateStart.setDate(dateStart.getDate() - 30);

        this.datesFilter.setDateRange(dateStart, date);
    }

    protected getTemplateName(): string{

        return "heavyHitters_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            formOptions                                : ko.observableArray([])
            ,formOptionSelected                         : ko.observable("all")
            ,collapseButtonClass                        : ko.observable("i-expand")
            ,collapseButtonText                         : ko.observable("expand")
            ,graphData                                  : ko.observableArray([])
            ,graphLinesInfo                             : ko.observableArray([])
            ,isDataLoading                              : ko.observable(0)
            ,onFormOptionChange                         : function(data) {huit_neuf_this.onFormOptionChange(data); }
            ,onArticleTypeChange                        : function(data){ huit_neuf_this.onArticleTypeChange(); }
            ,onCollapseClick                            : function(){ huit_neuf_this.onCollapseClick(); }
        };
    }

    private onFormOptionChange(selectedOption){

        this.caller.getListData();
    }

    public getViewModelForRequest(){

        return {
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            brandSegments: this.getTemplateViewModel().brandSegmentsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            postPaymentCategorySystems: this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems(),
            primaryCategory: this.getTemplateViewModel().primaryCategoriesFilter.idSelectedItem(),
            primaryCategoryName: this.getTemplateViewModel().primaryCategoriesFilter.nameSelectedItem(),
            primaryTag: this.getTemplateViewModel().primaryTagFilter.idSelectedItem(),
            primaryTagName: this.getTemplateViewModel().primaryTagFilter.nameSelectedItem(),
            tag: this.getTemplateViewModel().tagsFilter.idSelectedItem(),
            tagName: this.getTemplateViewModel().tagsFilter.nameSelectedItem(),
            tagType: this.getTemplateViewModel().tagTypesFilter.idSelectedItem(),
            tagTypeName: this.getTemplateViewModel().tagTypesFilter.nameSelectedItem(),
            srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
            srEditorNames: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
            jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
            jrEditorNames: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
            authors: this.getTemplateViewModel().authorsFilter.selectedItemIds(),
            authorNames: this.getTemplateViewModel().authorsFilter.selectedItemNames(),
            ideators: this.getTemplateViewModel().ideatorsFilter.selectedItemIds(),
            ideatorNames: this.getTemplateViewModel().ideatorsFilter.selectedItemNames(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            articleTypes: this.getTemplateViewModel().articleTypesFilter.selectedItems(),
            postContentTypesGroup: this.getTemplateViewModel().formOptionSelected(),
            collapseButtonText: this.getTemplateViewModel().collapseButtonText(),
            
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);
        return container;
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        
        this.datesFilter.buildCalendar();
    }

    public setPostPaymentCategorySystemFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no systems'});
        this.postPaymentCategorySystemFilter.setItems(items);
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){

            let brands = [];
            for( let brand of department.brands){

                if(brand.segments.length > 0){

                    for(let segment of brand.segments){

                        brands.push(segment);
                    }
                }
                else{

                    brands.push(brand);
                }
            }
            let group = {"name" : department.name, "logo" : department.logo, "items" : brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setBrandSegments(brandSegments){

        let groups = [];
        for (let brand of brandSegments){

            let segments = [];
            for( let segment of brand.segments){

                segments.push(segment);
            }

            let group = {"name" : brand.name, "items" : segments};
            groups.push(group);
        }
        this.brandSegmentsFilter.setMultiSectionItems(groups);
        this.brandSegmentsFilter.setLabel('Segments');
    }

    public setPostInitiativesFilterItems(items){

        for (let item of items){

            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }


    public setSelectedPostInitiative(idMapping) {

        this.postInitiativesFilter.setSelectedItems([idMapping]);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setTagsFilterItems(items){

        this.tagsFilter.setItems(items);
    }

    public setPrimaryTagFilterItems(items){

        this.primaryTagFilter.setItems(items);
    }

    public setTagTypesFilterItems(items){

        this.tagTypesFilter.setItems(items);
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.jrEditorsFilter.setItems(items);
    }

    public setAuthorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.authorsFilter.setItems(items);
    }

    public setIdeatorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.ideatorsFilter.setItems(items);
    }

    public setPostContentTypesGroupFilterItems(){

        this.getTemplateViewModel().formOptions(this.contentTypesGroup);
    }

    public setArticleTypesFilterItems(){

        this.articleTypesFilter.setItems(this.articleTypes);
    }

    public setGraphLinesInfo(graphLinesInfo){

        this.getTemplateViewModel().graphLinesInfo(graphLinesInfo);
    }

    public updateGraphData(data) {

        this.getTemplateViewModel().graphData(data);
        this.updateGraph();
    }

    private encodeValue(paramValue){

        if(paramValue == null){

            return false;
        }

        if(Array.isArray(paramValue)){
            if(paramValue.length == 0){
                return false;
            }

            paramValue = JSON.stringify(paramValue);
            paramValue = encodeURIComponent(paramValue);
        }

        if(typeof paramValue === 'object'){

            paramValue = JSON.stringify(paramValue);
            paramValue = encodeURIComponent(paramValue);
        }

        if(typeof paramValue === 'function'){

            let functionValue = paramValue();
            if(functionValue){
                paramValue = JSON.stringify(functionValue);
                paramValue = encodeURIComponent(functionValue);
            }else{
                return false;
            }
        }

        return paramValue;
    }

    private encodeIds(ids){

        let intIds = [];

        for(let id of ids){

            intIds.push(parseInt(id));
        }

        return encodeURIComponent('[' + intIds.join(',') + ']');
    }

    public getAALinkBaseParams() {

        let aaLinkParams = [];

        if(this.getTemplateViewModel().brandsFilter.selectedItems() !== null && this.getTemplateViewModel().brandsFilter.selectedItems().length > 0){

            aaLinkParams['brands'] = this.encodeIds(this.getTemplateViewModel().brandsFilter.selectedItems());
        }

        if(this.getTemplateViewModel().brandSegmentsFilter.selectedItems() !== null && this.getTemplateViewModel().brandSegmentsFilter.selectedItems().length > 0){

            aaLinkParams['brandSegments'] = this.encodeValue(this.getTemplateViewModel().brandSegmentsFilter.selectedItems());
        }

        if(this.getTemplateViewModel().postIntentsFilter.selectedItems() !== null && this.getTemplateViewModel().postIntentsFilter.selectedItems().length > 0){

            aaLinkParams['postIntents'] = this.encodeValue(this.getTemplateViewModel().postIntentsFilter.selectedItems());
        }

        if(this.getTemplateViewModel().postContentTypesFilter.selectedItems() !== null && this.getTemplateViewModel().postContentTypesFilter.selectedItems().length > 0){

            aaLinkParams['postContentTypes'] = this.encodeValue(this.getTemplateViewModel().postContentTypesFilter.selectedItems());
        }

        if(this.getTemplateViewModel().networkCategoriesFilter.selectedItems() !== null && this.getTemplateViewModel().networkCategoriesFilter.selectedItems().length > 0){

            aaLinkParams['networkCategories'] = this.encodeValue(this.getTemplateViewModel().networkCategoriesFilter.selectedItems());
        }

        if(this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems() !== null && this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems().length > 0){

            aaLinkParams['postPaymentCategorySystems'] = this.encodeValue(this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems());
        }

        if(this.getTemplateViewModel().srEditorsFilter.selectedItems() !== null && this.getTemplateViewModel().srEditorsFilter.selectedItems().length > 0){

            aaLinkParams['srEditors'] = this.encodeValue(this.getTemplateViewModel().srEditorsFilter.selectedItemIds());
            aaLinkParams['srEditorNames'] = this.encodeValue(this.getTemplateViewModel().srEditorsFilter.selectedItemNames());
        }

        if(this.getTemplateViewModel().jrEditorsFilter.selectedItems() !== null && this.getTemplateViewModel().jrEditorsFilter.selectedItems().length > 0){

            aaLinkParams['jrEditors'] = this.encodeValue(this.getTemplateViewModel().jrEditorsFilter.selectedItemIds());
            aaLinkParams['jrEditorNames'] = this.encodeValue(this.getTemplateViewModel().jrEditorsFilter.selectedItemNames());
        }

        if(this.getTemplateViewModel().authorsFilter.selectedItems() !== null && this.getTemplateViewModel().authorsFilter.selectedItems().length > 0){

            aaLinkParams['authors'] = this.encodeValue(this.getTemplateViewModel().authorsFilter.selectedItemIds());
            aaLinkParams['authorNames'] = this.encodeValue(this.getTemplateViewModel().authorsFilter.selectedItemNames());
        }

        aaLinkParams['publishStatus'] = encodeURIComponent('publish');


        aaLinkParams['trafficSource'] = encodeURIComponent(2);

        aaLinkParams['postInitiatives'] = encodeURIComponent(JSON.stringify([10])); // Editorial

        if(this.getTemplateViewModel().formOptionSelected()){

            aaLinkParams['postContentTypesGroup'] = encodeURIComponent(this.getTemplateViewModel().formOptionSelected());
        }

         if(this.getTemplateViewModel().articleTypesFilter.selectedItems() !== null && this.getTemplateViewModel().articleTypesFilter.selectedItems().length > 0){

            // not an array in aa, so we take the first element
            for (let articleType of this.getTemplateViewModel().articleTypesFilter.selectedItems()){

                aaLinkParams['articleType'] = articleType.toLowerCase();
                break;
            }
        }

        let idPrimaryCategory = this.getTemplateViewModel().primaryCategoriesFilter.idSelectedItem();
        if (idPrimaryCategory != null){
            aaLinkParams['primaryCategory'] = encodeURIComponent(parseInt(idPrimaryCategory));
        }
        
        let namePrimaryCategory = this.getTemplateViewModel().primaryCategoriesFilter.nameSelectedItem();
        if (namePrimaryCategory != null){
            aaLinkParams['primaryCategoryName'] = encodeURIComponent(namePrimaryCategory);
        }

        let idPrimaryTag = this.getTemplateViewModel().primaryTagFilter.idSelectedItem();
        if (idPrimaryTag != null){
            aaLinkParams['primaryTag'] = encodeURIComponent(parseInt(idPrimaryTag));
        }

        let namePrimaryTag = this.getTemplateViewModel().primaryTagFilter.nameSelectedItem();
        if (namePrimaryTag != null){
            aaLinkParams['primaryTagName'] = encodeURIComponent(namePrimaryTag);
        }

        let idTag = this.getTemplateViewModel().tagsFilter.idSelectedItem();
        if (idTag != null){
            aaLinkParams['tag'] = encodeURIComponent(parseInt(idTag));
        }


        return aaLinkParams;
    }

    public getAAlink(params){

        let aaLink = 'https://pubinsights.com/article_analysis?viewMode=article&orderBy=sessionsSentinel&orderByDirection=DESC&orderByAndDirection=sessionsSentinel_DESC';

        for (const key in params){

            const indexedItem = params[key];
            aaLink = aaLink + '&' + key + '=' + indexedItem;
        }

        return aaLink;
    }

    public updateGraph() {

        let aaBaseParams = this.getAALinkBaseParams();

        let aaLink = this.getAAlink(aaBaseParams);
        this.chart.setCssHeight("400px");
        this.chart.setDateField("date");
        this.chart.setCursorEnabled(1);
        this.chart.setLabelMaxWidth(80);
        this.chart.setAutoRotateLabels(1);
        this.chart.setClickableLegend(1);
        this.chart.setNoDataMessage("No data available");

        let chart = this.chart.setupChart(this.getTemplateViewModel().graphData());

        const allData = this.getTemplateViewModel().graphData();

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const twoDaysAgo = new Date(today);
        twoDaysAgo.setDate(today.getDate() - 2);

        const fourDaysAgo = new Date(today);
        fourDaysAgo.setDate(today.getDate() - 4);

        const untilFourDaysAgoData = allData.filter(d => {
            const date = new Date(d.date);
            date.setHours(0, 0, 0, 0);
            return date <= fourDaysAgo;
        });

        const afterFourDaysAgoData = allData.filter(d => {
            const date = new Date(d.date);
            date.setHours(0, 0, 0, 0);
            return date >= fourDaysAgo;
        });

        const untilTwoDaysAgoData = allData.filter(d => {
            const date = new Date(d.date);
            date.setHours(0, 0, 0, 0);
            return date <= twoDaysAgo;
        });

        const afterTwoDaysAgoData = allData.filter(d => {
            const date = new Date(d.date);
            date.setHours(0, 0, 0, 0);
            return date >= twoDaysAgo;
        });

        let firstItem = true;

        for (let graphLinesInfo of this.getTemplateViewModel().graphLinesInfo()) {

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            this.chart.applyValueAxisFormatting(valueAxis);
            valueAxis.renderer.minWidth = 50;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.renderer.opposite = true;
            valueAxis.min = 0;
            if (firstItem) {

                valueAxis.title.text = "Content Champs - Heavy Hitters";
                valueAxis.title.fontWeight = "bold";
                firstItem = false;
                valueAxis.renderer.opposite = false;
            }
            
            for (let fieldName of graphLinesInfo) {

                let groupings:any = [];

                if (fieldName.name == "HH Count") {

                    groupings = [untilFourDaysAgoData, afterFourDaysAgoData];
                }
                else if (fieldName.name == "HH Daily Target") {
                    groupings = [untilTwoDaysAgoData, afterTwoDaysAgoData];
                }
                else if (fieldName.name == "aS/A") {
                    groupings = [untilTwoDaysAgoData, afterTwoDaysAgoData];
                }
                
                for (let dataSplit of groupings) {

                    if (dataSplit.length == 0) {
                        continue;
                    }
                    let isEstimate = dataSplit === afterFourDaysAgoData || dataSplit === afterTwoDaysAgoData;

                    let series = chart.series.push(new am4charts.LineSeries());
                    series.dataItems.template.locations.categoryX = 0.5;
                    series.name = isEstimate ? fieldName.name + " (Estimate)" : fieldName.name;
                    series.dataFields.valueY = fieldName.field;
                    series.dataFields.dateX = "date";
                    series.strokeOpacity = 1;
                    series.strokeWidth = 2;
                    series.fill = am4core.color(fieldName.color);
                    series.stroke = am4core.color(fieldName.color);
                    series.yAxis = valueAxis;
                    series.smoothing = "monotoneX";
                    series.showOnInit = true;
                    series.strokeDasharray = "4,4";
                    series.data = dataSplit;
                    if (!isEstimate) {
                        series.strokeDasharray = "";
                    }
                    
                    let interfaceColors = new am4core.InterfaceColorSet();
                    let bullet = series.bullets.push(new am4charts.CircleBullet());
                    bullet.circle.stroke = interfaceColors.getFor("background");
                    bullet.circle.strokeWidth = 2;
                    bullet.cursorOverStyle = am4core.MouseCursorStyle.pointer;
                    bullet.events.on("hit", function(ev) {
                        let data:any = ev.target.dataItem?.dataContext;
                        let splitLink = aaLink.split('?');
                        let qp = new URLSearchParams(splitLink[1]);
                        qp.append('startDate', data.date);
                        qp.append('endDate', data.date);
                        window.open(`${splitLink[0]}?${qp.toString()}`, "_blank");
                    });

                    if (fieldName.name == "HH Count") {
                        series.dataFields.customValue = fieldName.customValue;
                        bullet.tooltipText = "{name}: [bold]{valueY.value} ({customValue}%)[/]";
                    }
                    else if(fieldName.name == "HH Daily Target") {
                        series.dataFields.customValue = fieldName.customValue;
                        bullet.tooltipText = "{name}: [bold]{valueY.value}[/]\nArticles Published: [bold]{customValue}[/]";
                    }
                    else {
                        bullet.tooltipText = "{name}: [bold]{valueY.value}[/]";
                    }
                }
            }
        }
    }

    private onArticleTypeChange(){

        this.caller.getListData();
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.brandSegmentsFilter, params['brandSegments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postPaymentCategorySystemFilter, params['postPaymentCategorySystems']);

        this.presetFilter.setAutocompletePresetFilter(this.primaryCategoriesFilter, params['primaryCategory'], params['primaryCategoryName']);
        this.presetFilter.setAutocompletePresetFilter(this.primaryTagFilter, params['primaryTag'], params['primaryTagName']);
        this.presetFilter.setAutocompletePresetFilter(this.tagsFilter, params['tag'], params['tagName']);
        this.presetFilter.setAutocompletePresetFilter(this.tagTypesFilter, params['tagType'], params['tagTypeName']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['srEditors'], params['srEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['jrEditors'], params['jrEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.authorsFilter, params['authors'], params['authorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.ideatorsFilter, params['ideators'], params['ideatorNames']);

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        this.presetFilter.setMultiSelectorPresetFilters(this.articleTypesFilter, params['articleTypes']);

        if(typeof params['postContentTypesGroup'] !== 'undefined') {

            this.getTemplateViewModel().formOptionSelected(params['postContentTypesGroup']);
        }

        if(typeof params['collapseButtonText'] !== 'undefined') {

            if (params['collapseButtonText'] == 'simplify') {


                this.getTemplateViewModel().collapseButtonClass('i-simplify');
                this.getTemplateViewModel().collapseButtonText('simplify');
            } else {

                this.getTemplateViewModel().collapseButtonClass('i-expand');
                this.getTemplateViewModel().collapseButtonText('expand');
            }
        }
    }

    private onCollapseClick(){

        if(this.getTemplateViewModel().collapseButtonText() == 'simplify'){

            this.getTemplateViewModel().collapseButtonClass('i-expand');
            this.getTemplateViewModel().collapseButtonText('expand');
        }else{

            this.getTemplateViewModel().collapseButtonClass('i-simplify');
            this.getTemplateViewModel().collapseButtonText('simplify');
        }

        this.caller.getListData();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/heavyHitters_template.ts